module.exports = __webpack_public_path__ + "img/专属商务经理.c6aa39cd.png";